import * as Styled from './styled'

import { Props } from './interfaces'

const Skeleton = ({ isLoading, $height, $margin, $width, Component, $border }: Props) => {
  if (isLoading) return <Styled.Skeleton $height={$height} $margin={$margin} $width={$width} $border={$border} />

  return <>{Component}</>
}

export default Skeleton
